const WinlosesTypes = {
    FETCH_START:    '[MUSIC][WINLOSES] FETCH START',
    FETCH_SUCCESS:  '[MUSIC][WINLOSES] FETCH SUCCESS',
    FETCH_FAILURE:  '[MUSIC][WINLOSES] FETCH FAILURE'
};

export default WinlosesTypes;